import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import {
  doc,
  serverTimestamp,
  runTransaction,
  increment,
} from "firebase/firestore";
import { db } from "../services/firebase";
import "./Welcome.css";
import bibFormBg from "../assets/images/optimized/bibForm.png";
import Header from "../components/Header";

const FindMyRoute = () => {
  const [bibNumber, setBibNumber] = useState("36584605");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Function to track BIB number usage in Firebase
  const trackBibUsage = async (bibNumber) => {
    try {
      // Validate BIB number
      const bibNum = parseInt(bibNumber);
      if (isNaN(bibNum)) {
        console.error("Invalid BIB number:", bibNumber);
        return;
      }

      const bibRecord = {
        bibNumber: bibNum,
        lastUsed: serverTimestamp(),
        usageCount: 1,
        firstUsed: serverTimestamp(),
        firstTimezone:
          Intl.DateTimeFormat().resolvedOptions().timeZone || "Unknown",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Unknown",
        userAgent: navigator.userAgent || "Unknown",
      };

      // Use BIB number as document ID
      const docId = bibNum.toString();

      console.log("Attempting to store BIB usage:", {
        bibNumber: bibNum,
        docId,
      });

      // Use runTransaction to ensure atomicity
      await runTransaction(db, async (transaction) => {
        const docRef = doc(db, "bibUsage", docId);
        const docSnap = await transaction.get(docRef);

        if (docSnap.exists()) {
          // Document exists, update existing record
          // Note: firstUsed and firstTimezone are preserved, never updated
          transaction.update(docRef, {
            lastUsed: serverTimestamp(),
            usageCount: increment(1),
            timezone:
              Intl.DateTimeFormat().resolvedOptions().timeZone || "Unknown",
            userAgent: navigator.userAgent || "Unknown",
          });
        } else {
          // Document doesn't exist, create new one
          // This sets firstUsed, firstTimezone, and initial timezone
          transaction.set(docRef, bibRecord);
        }
      });

      console.log("BIB usage tracked successfully:", bibNum);
    } catch (error) {
      console.error("Error tracking BIB usage:", error);
      console.error("Error details:", {
        code: error.code,
        message: error.message,
        stack: error.stack,
      });
      // Don't throw error to avoid blocking the user flow
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!bibNumber.trim()) {
      toast.error("Please enter your BIB number");
      return;
    }

    setIsLoading(true);

    try {
      // Track BIB usage in Firebase (non-blocking)
      trackBibUsage(bibNumber).catch((error) => {
        console.error("BIB tracking failed but continuing:", error);
      });

      console.log("BIB Number submitted:", bibNumber);

      // Navigate to Wayfinder with BIB number
      navigate("/wayfinder", {
        state: { bibNumber: parseInt(bibNumber) },
      });
    } catch (error) {
      console.error("Error processing BIB submission:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setBibNumber(e.target.value);
  };

  return (
    <div className="welcome-screen">
      <Header />
      <div className="form-background">
        <div className="form-image-container">
          <img
            src={bibFormBg}
            alt="Marathon runners"
            style={{
              marginTop: 60,
              objectFit: "contain",
            }}
          />
        </div>
        <div className="center-card" style={{ height: `calc(100% - 30vh)` }}>
          <div className="form-content">
            <div className="form-welcome">
              <h1>Find My Route</h1>
              <p>
                Enter your Confirmation Number to get your personalized walking
                route.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="registration-form">
              <div className="form-group">
                <label>Confirmation Number</label>
                <input
                  type="text"
                  value={bibNumber}
                  onChange={handleInputChange}
                  placeholder="Enter your Confirmation Number"
                  disabled={isLoading}
                />
              </div>
              <button
                type="submit"
                className="send-otp-button"
                disabled={isLoading || !bibNumber.trim()}
              >
                {isLoading ? "PROCESSING..." : "SUBMIT"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindMyRoute;
